import {
    Box,
    Breadcrumbs,
    Divider,
    FormControl,
    FormLabel,
    Link,
    Sheet,
    Switch,
    Typography,
} from "@mui/joy";
import { ChevronRight } from "lucide-react";
import { Link as RouterLink, Navigate } from "react-router-dom";

import { useAuthorization, useShowFormulaTooltips } from "../../hooks";
import { ROLES } from "../../constants/permissions";

function Breadcrumb() {
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{ mt: 0, ml: 1, mr: 2 }}
        >
            <Breadcrumbs separator={<ChevronRight size={18} />}>
                <Link
                    component={RouterLink}
                    to="/admin"
                    level="title-lg"
                    sx={{
                        fontWeight: 500,
                        textDecoration: "none",
                        color: "inherit",
                        "&:hover": { textDecoration: "underline" },
                    }}
                >
                    Admin
                </Link>
                <Link
                    component={RouterLink}
                    to="/admin/tenant/admins"
                    level="body-md"
                    sx={{
                        fontWeight: 500,
                        textDecoration: "none",
                        color: "inherit",
                        "&:hover": { textDecoration: "underline" },
                    }}
                >
                    Tenant
                </Link>
                <Typography level="body-md" sx={{ fontWeight: 500 }}>
                    General
                </Typography>
            </Breadcrumbs>
        </Box>
    );
}

export function TenantGeneralSettings() {
    const { hasRole } = useAuthorization();
    const isSuperAdmin = hasRole(ROLES.SUPER_ADMIN);
    const { enabled, setEnabled } = useShowFormulaTooltips();

    if (!isSuperAdmin) {
        return <Navigate to="/admin/general" replace />;
    }

    return (
        <Box
            flex={1}
            display="flex"
            flexDirection="column"
            maxHeight="100%"
            sx={{ overflow: "hidden", minWidth: 0, minHeight: 0 }}
        >
            <Breadcrumb />
            <Divider sx={{ mt: 0, ml: 0 }} />

            <Box flex={1} sx={{ minWidth: 0, overflow: "auto" }}>
                <Box
                    sx={{
                        px: { xs: 2, sm: 3 },
                        pt: 2.5,
                        pb: 4,
                        maxWidth: 920,
                    }}
                >
                    <Sheet
                        variant="outlined"
                        sx={{
                            borderRadius: "4px",
                            p: { xs: 2, sm: 2.5 },
                            bgcolor: "background.surface",
                        }}
                    >
                        <FormControl
                            orientation="horizontal"
                            sx={{
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: 2,
                            }}
                        >
                            <Box>
                                <FormLabel sx={{ mb: 0 }}>
                                    Show formula tooltips
                                </FormLabel>
                                <Typography
                                    level="body-sm"
                                    sx={{ color: "text.secondary" }}
                                >
                                    Show quantity formula details on hover
                                </Typography>
                            </Box>
                            <Switch
                                checked={enabled}
                                onChange={(e) => setEnabled(e.target.checked)}
                            />
                        </FormControl>
                    </Sheet>
                </Box>
            </Box>
        </Box>
    );
}
